import React, { useState, useEffect } from "react";
import {
  Form,
  InputNumber,
  Select,
  DatePicker,
  Typography,
  Table,
  Divider,
  Button,
  message,
} from "antd";
import { SaveFilled } from "@ant-design/icons";
import moment from "moment";
import dayjs from "dayjs";
import { getKaryawanById, dropdownKaryawan } from "../../api/master/Karyawan";
import { postGaji } from "../../api/transaksi/Gaji";

const sessiData = JSON.parse(sessionStorage.getItem("user"));
const { Option } = Select;
const { Text } = Typography;

const AddSalaryForm = () => {
  const [form] = Form.useForm();
  const [listKaryawan, setListKaryawan] = useState([]);
  const [totalGajiKotor, setTotalGajiKotor] = useState(0);
  const [totalGaji, setTotalGaji] = useState(0);
  const [periodeSelected, setPeriodeSelected] = useState(dayjs());
  const [loadingNama, setLoadingNama] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  useEffect(() => {
    fetchKaryawan();
    form.setFieldsValue({
      periode: dayjs(),
    });
  }, []);

  const fetchKaryawan = async () => {
    try {
      const res = await dropdownKaryawan();
      setListKaryawan(res.data);
    } catch {
      message.error("Gagal memuat karyawan.");
    }
  };
  const hitungTotal = (
    gapok,
    tunjangan = [],
    tunjanganKaryawan = [],
    lemburAll = [],
    insentifAll = [],
    potongan = []
  ) => {
    const sum = (arr) =>
      (arr || []).reduce((a, b) => a + Number(b.nominal || 0), 0);

    // Gaji kotor: semua data dihitung
    const totalKotor =
      Number(gapok || 0) +
      sum(tunjangan) +
      sum(tunjanganKaryawan) +
      sum(lemburAll) +
      sum(insentifAll) -
      sum(potongan);
    setTotalGajiKotor(totalKotor);

    // Gaji bersih: hanya lembur & insentif yang belum dibayar
    const lemburBelumDibayar = lemburAll.filter((d) => !d.tanggal_dibayar);
    const insentifBelumDibayar = insentifAll.filter((d) => !d.tanggal_dibayar);

    const totalDiterima =
      Number(gapok || 0) +
      sum(tunjangan) +
      sum(tunjanganKaryawan) +
      sum(lemburBelumDibayar) +
      sum(insentifBelumDibayar) -
      sum(potongan);

    setTotalGaji(totalDiterima);
  };

  const handleNamaChange = async (value) => {
    setLoadingNama(true);
    try {
      const periode = form.getFieldValue("periode").format("YYYY-MM");
      const res = await getKaryawanById(value, periode);

      if (res.status) {
        const {
          emp_gaji_pokok,
          tunjangan,
          tunjangan_karyawan,
          lembur,
          insentif,
          potongan,
        } = res.data;

        const convert = (data) =>
          (data || []).map((d) => ({ ...d, tanggal: moment(d.tanggal) }));

        const tunjanganData = convert(tunjangan);
        const tunjanganKaryawan = convert(tunjangan_karyawan);
        const lemburData = convert(lembur);
        const insentifData = convert(insentif);
        const potonganData = convert(potongan);

        form.setFieldsValue({
          gaji_pokok: emp_gaji_pokok,
          tunjangan: tunjanganData,
          tunjangan_karyawan: tunjanganKaryawan,
          lembur: lemburData,
          insentif: insentifData,
          potongan: potonganData,
        });

        hitungTotal(
          emp_gaji_pokok,
          tunjanganData,
          tunjanganKaryawan,
          lemburData,
          insentifData,
          potonganData
        );
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Terjadi kesalahan saat mengambil data";
      message.error(errorMessage);
    }
    setLoadingNama(false);
  };

  const handleNamaChange_2 = async (value) => {
    setLoadingNama(true);
    try {
      const periode = form.getFieldValue("periode").format("YYYY-MM");
      const res = await getKaryawanById(value, periode);
      if (res.status) {
        const { emp_gaji_pokok, tunjangan, lembur, insentif, potongan } =
          res.data;

        const convert = (data) =>
          (data || []).map((d) => ({ ...d, tanggal: moment(d.tanggal) }));

        const lemburBelumDibayar =
          lembur?.filter((item) => item.tanggal_dibayar === null) || [];
        const insentifBelumDibayar =
          insentif?.filter((item) => item.tanggal_dibayar === null) || [];

        form.setFieldsValue({
          gaji_pokok: emp_gaji_pokok,
          tunjangan: convert(tunjangan),
          lembur: convert(lembur),
          insentif: convert(insentif),
          potongan: convert(potongan),
        });

        hitungTotal(
          emp_gaji_pokok,
          tunjangan,
          lemburBelumDibayar,
          insentifBelumDibayar,
          potongan
        );
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Terjadi kesalahan saat mengambil data";
      message.error(errorMessage);
    }
    setLoadingNama(false);
  };

  const handlePeriodeChange = (val) => {
    setPeriodeSelected(val);
    form.setFieldsValue({ periode: val });

    const nama = form.getFieldValue("nama");
    if (nama) {
      handleNamaChange(nama);
    }
  };

  const onValuesChange = (_, all) => {
    hitungTotal(
      all.gaji_pokok,
      all.tunjangan,
      all.tunjangan_karyawan,
      all.lembur,
      all.insentif,
      all.potongan
    );
  };

  const formatRupiah = (value) =>
    `${Number(value).toLocaleString("id-ID", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const urutkanBelumDibayarDulu = (data) => {
    return [...(data || [])].sort((a, b) => {
      if (a.tanggal_dibayar === null && b.tanggal_dibayar !== null) return -1;
      if (a.tanggal_dibayar !== null && b.tanggal_dibayar === null) return 1;
      return 0; // kalau dua-duanya null atau dua-duanya sudah dibayar, tetap urutan asli
    });
  };

  const tunjanganColumns = [
    {
      title: "Keterangan",
      dataIndex: "keterangan",
    },
    {
      title: "Nominal",
      dataIndex: "nominal",
      align: "right",
      render: (val) => formatRupiah(val),
    },
  ];

  const tunjanganKaryawanColumns = [
    {
      title: "Keterangan",
      dataIndex: "keterangan",
    },
    {
      title: "Nominal",
      dataIndex: "nominal",
      align: "right",
      render: (val) => formatRupiah(val),
    },
  ];

  const lemburColumns = [
    { title: "Keterangan", dataIndex: "keterangan" },
    {
      title: "Status Pembayaran",
      dataIndex: "status_pembayaran",
      render: (val) => val || "-",
    },
    {
      title: "Tanggal Dibayarkan",
      dataIndex: "tanggal_dibayar",
      render: (val) => (val ? moment(val).format("YYYY-MM-DD") : "-"),
    },
    {
      title: "Nominal",
      dataIndex: "nominal",
      align: "right",
      render: (_, record) =>
        record.tanggal_dibayar ? (
          <del>{formatRupiah(record.nominal)}</del>
        ) : (
          formatRupiah(record.nominal)
        ),
    },
  ];

  const insentifColumns = [
    { title: "Keterangan", dataIndex: "keterangan" },
    {
      title: "Status Pembayaran",
      dataIndex: "status_pembayaran",
      render: (val) => val || "-",
    },
    {
      title: "Tanggal Dibayarkan",
      dataIndex: "tanggal_dibayar",
      render: (val) => (val ? moment(val).format("YYYY-MM-DD") : "-"),
    },
    {
      title: "Nominal",
      dataIndex: "nominal",
      align: "right",
      render: (_, record) =>
        record.tanggal_dibayar ? (
          <del>{formatRupiah(record.nominal)}</del>
        ) : (
          formatRupiah(record.nominal)
        ),
    },
  ];

  const potonganColumns = [
    {
      title: "Keterangan",
      dataIndex: "keterangan",
    },
    {
      title: "Nominal",
      dataIndex: "nominal",
      align: "right",
      render: (val) => <Text type="danger">{formatRupiah("-" + val)}</Text>,
    },
  ];

  const sumFooterPembayaran = (data, label) => {
    const sudahDibayar = (data || []).filter((d) => d.tanggal_dibayar !== null);
    const belumDibayar = (data || []).filter((d) => d.tanggal_dibayar === null);

    const sum = (arr) =>
      (arr || []).reduce((acc, cur) => acc + Number(cur.nominal || 0), 0);

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 16px",
        }}
      >
        <Text strong style={{ textTransform: "uppercase" }}>
          TOTAL {label} SUDAH DIBAYAR: {formatRupiah(sum(sudahDibayar))}
        </Text>

        <Text strong style={{ textTransform: "uppercase" }}>
          TOTAL {label} BELUM DIBAYAR: {formatRupiah(sum(belumDibayar))}
        </Text>
      </div>
    );
  };

  const sumFooter = (data, label) => {
    const total = data.reduce((acc, cur) => acc + Number(cur.nominal || 0), 0);
    return (
      <div style={{ textAlign: "right", paddingRight: 16 }}>
        <Text strong>
          TOTAL {label}: {formatRupiah(total)}
        </Text>
      </div>
    );
  };

  const onFinish = async (values) => {
    setLoadingSubmit(true);
    const sum = (arr) =>
      (arr || []).reduce((a, b) => a + Number(b.nominal || 0), 0);
    const payload = {
      gji_id_karyawan: values.nama,
      gji_periode: values.periode.format("YYYY-MM"),
      gji_gapok: Number(values.gaji_pokok || 0),
      gji_tunjangan: sum(values.tunjangan),
      gji_tunjangan_karyawan: sum(values.tunjangan_karyawan),
      gji_lembur: sum(values.lembur),
      gji_insentive: sum(values.insentif),
      gji_potongan: sum(values.potongan),
      gji_total_gaji: totalGajiKotor,
      gji_total_diterima: totalGaji,
      gji_status: "Paid",
      gji_tanggal_bayar: values.tanggal_dibayarkan?.format("YYYY-MM-DD"),
      gji_pph: values.gji_pph,
      gji_created_by: sessiData[0].user[0].fullname,
    };

    try {
      const res = await postGaji(payload);
      if (res.status) {
        message.success("Data gaji berhasil disimpan.");
        form.resetFields();
        form.setFieldsValue({ periode: dayjs() });
        setTotalGaji(0);
        setTotalGajiKotor(0);
      } else {
        message.error(res.message);
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Terjadi kesalahan saat submit data";
      message.error(errorMessage);
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <div>
      <Divider>Input Gaji Karyawan</Divider>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        loading={loadingSubmit}
        style={{ maxWidth: 800, margin: "auto" }}
      >
        <Form.Item
          name="periode"
          label="Periode Gaji"
          rules={[{ required: true }]}
        >
          <DatePicker
            picker="month"
            style={{ width: "100%" }}
            value={periodeSelected}
            onChange={handlePeriodeChange}
          />
        </Form.Item>

        <Form.Item
          name="nama"
          label="Nama Karyawan"
          rules={[{ required: true }]}
        >
          <Select onChange={handleNamaChange} placeholder="Pilih karyawan">
            {listKaryawan.map((k) => (
              <Option key={k.emp_id_karyawan} value={k.emp_id_karyawan}>
                {k.emp_nama}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="gaji_pokok"
          label="Gaji Pokok"
          rules={[{ required: true }]}
        >
          <InputNumber
            style={{ width: "100%" }}
            formatter={(val) =>
              val ? `Rp ${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
            }
            parser={(val) => val.replace(/[^0-9]/g, "")}
            disabled
          />
        </Form.Item>

        <Divider>Tunjangan Jabatan</Divider>
        <Form.Item name="tunjangan" noStyle>
          <Table
            columns={tunjanganColumns}
            loading={loadingNama}
            dataSource={form.getFieldValue("tunjangan") || []}
            pagination={false}
            rowKey="id"
            footer={() =>
              sumFooter(
                form.getFieldValue("tunjangan") || [],
                "TUNJANGAN JABATAN"
              )
            }
          />
        </Form.Item>

        <Divider>Tunjangan Karyawan</Divider>
        <Form.Item name="tunjangan_karyawan" noStyle>
          <Table
            columns={tunjanganKaryawanColumns}
            loading={loadingNama}
            dataSource={form.getFieldValue("tunjangan_karyawan") || []}
            pagination={false}
            rowKey="id"
            footer={() =>
              sumFooter(
                form.getFieldValue("tunjangan_karyawan") || [],
                "TUNJANGAN KARYAWAN"
              )
            }
          />
        </Form.Item>

        <Divider>Lembur</Divider>
        <Form.Item name="lembur" noStyle>
          <Table
            columns={lemburColumns}
            loading={loadingNama}
            dataSource={urutkanBelumDibayarDulu(
              form.getFieldValue("lembur") || []
            )}
            pagination={false}
            rowKey="id"
            footer={() =>
              sumFooterPembayaran(form.getFieldValue("lembur") || [], "LEMBUR")
            }
          />
        </Form.Item>

        <Divider>Insentif / Bonus</Divider>
        <Form.Item name="insentif" noStyle>
          <Table
            columns={insentifColumns}
            loading={loadingNama}
            dataSource={urutkanBelumDibayarDulu(
              form.getFieldValue("insentif") || []
            )}
            pagination={false}
            rowKey="id"
            footer={() =>
              sumFooterPembayaran(
                form.getFieldValue("insentif") || [],
                "INSENTIF"
              )
            }
          />
        </Form.Item>

        <Divider>Potongan Gaji</Divider>
        <Form.Item name="potongan" noStyle>
          <Table
            columns={potonganColumns}
            loading={loadingNama}
            dataSource={form.getFieldValue("potongan") || []}
            pagination={false}
            rowKey="id"
            footer={() =>
              sumFooter(form.getFieldValue("potongan") || [], "POTONGAN GAJI")
            }
          />
        </Form.Item>

        <Divider />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            width: "100%",
            gap: 4,
            marginBottom: 16,
          }}
        >
          <div>
            <Text strong>TOTAL GAJI :</Text>
            <Text style={{ fontSize: 16, marginLeft: 8 }}>
              {formatRupiah(totalGajiKotor)}
            </Text>
          </div>

          <div>
            <Text strong>TOTAL DITERIMA :</Text>
            <Text style={{ fontSize: 18, marginLeft: 8 }} type="success">
              {formatRupiah(totalGaji)}
            </Text>
          </div>
        </div>

        <Form.Item
          name="tanggal_dibayarkan"
          label="Tanggal Dibayarkan"
          rules={[{ required: true, message: "Wajib diisi" }]}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item name="gji_pph" label="PPH21">
          <InputNumber
            min={0}
            step={0.01}
            style={{ width: "100%" }}
            formatter={(value) =>
              value ? `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
            }
            parser={(value) => value.replace(/Rp\s?|(,*)/g, "")}
          />
        </Form.Item>

        <div style={{ marginTop: 20 }}>
          <Button
            htmlType="submit"
            type="primary"
            loading={loadingSubmit}
            icon={<SaveFilled />}
            block
          >
            SUBMIT
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddSalaryForm;
